import { searchEcFormBuilderController } from '../../controller/searchEcFormBuilderController';

export default function fbFlashDirective() {
  return {
    restrict: 'A',
    scope: false,
    require: '^^?ecFormBuilder',
    link,
  };

  function link(scope, element, attrs, ecFormBuilderController) {
    try {
      ecFormBuilderController = ecFormBuilderController || searchEcFormBuilderController(scope);
    } catch (e) {
      console.error('fbFlash', e, element[0]);
      return;
    }

    let flashFn;
    const model = attrs.xPath,
      unbind = scope.$watch(attrs.fbFlash, fn => {
        if (typeof fn !== 'function') {
          return;
        }
        flashFn = fn;
        ecFormBuilderController.events.emit('fbFlash:register', {
          model,
          flashFn,
        });
      });

    scope.$on('$destroy', () => {
      ecFormBuilderController.events.emit('fbFlash:unregister', {
        model,
        flashFn,
      });
      unbind();
    });
  }
}
